import { render, staticRenderFns } from "./Stockistprofile.vue?vue&type=template&id=a053fe96"
import script from "./Stockistprofile.vue?vue&type=script&lang=js"
export * from "./Stockistprofile.vue?vue&type=script&lang=js"
import style0 from "./Stockistprofile.vue?vue&type=style&index=0&id=a053fe96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports